import { render, staticRenderFns } from "./mobile-skip.vue?vue&type=template&id=54413edd"
import script from "./mobile-skip.vue?vue&type=script&lang=js"
export * from "./mobile-skip.vue?vue&type=script&lang=js"
import style0 from "./mobile-skip.vue?vue&type=style&index=0&id=54413edd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports